function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListThumbnail(props) {
  const {
    image,
    hoverText,
    url,
    imageMetaData,
    thumbnailClassName
  } = props;
  const {
    isMobile
  } = useIsMobile();
  if (isMobile || !image) {
    return true;
  }
  const listThumbnailClass = classNames({
    [moduleStyles['sib-list__thumbnail']]: true,
    [thumbnailClassName]: !!thumbnailClassName
  });
  return /*#__PURE__*/React.createElement("div", {
    className: listThumbnailClass
  }, /*#__PURE__*/React.createElement("img", _extends({
    src: image,
    alt: "list_thumbnail"
  }, imageMetaData)), url && /*#__PURE__*/React.createElement("div", {
    className: moduleStyles['sib-list__thumbnail-overlay'],
    tabIndex: "-1",
    role: "presentation"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    label: hoverText,
    onClick: () => window.open(url, '_blank')
  })));
}
ListThumbnail.defaultProps = {
  imageMetaData: {},
  url: '',
  hoverText: '',
  thumbnailClassName: ''
};
ListThumbnail.propTypes = {
  image: PropTypes.string.isRequired,
  imageMetaData: PropTypes.shape({}),
  url: PropTypes.string,
  hoverText: PropTypes.string,
  thumbnailClassName: PropTypes.string
};
export default ListThumbnail;